import { P as c, A as b, b as l, n as s, t as f } from "./element-CV9utnHJ.js";
import { P as u } from "./pkt-slot-controller-D7CrjM52.js";
import { e as m } from "./class-map-3ADKve8g.js";
import { o as r } from "./if-defined-rXcLNTzN.js";
import { e as y, n as k } from "./ref-Dma3n3i8.js";
import "./icon-D0IQAVwS.js";
var g = Object.defineProperty, P = Object.getOwnPropertyDescriptor, e = (t, o, n, p) => {
  for (var a = p > 1 ? void 0 : p ? P(o, n) : o, d = t.length - 1, h; d >= 0; d--)
    (h = t[d]) && (a = (p ? h(o, n, a) : h(a)) || a);
  return p && a && g(o, n, a), a;
};
window.pktAnimationPath = window.pktAnimationPath || "https://punkt-cdn.oslo.kommune.no/latest/animations/";
let i = class extends c {
  constructor() {
    super(), this.defaultSlot = y(), this.iconName = "user", this.secondIconName = "user", this.mode = "light", this.size = "medium", this.fullWidth = !1, this.fullWidthOnMobile = !1, this.skin = "primary", this.variant = "label-only", this.state = "normal", this.type = "button", this.form = void 0, this.isLoading = !1, this.disabled = !1, this.loadingAnimationPath = window.pktAnimationPath, this.slotController = new u(this, this.defaultSlot);
  }
  // Lifecycle
  connectedCallback() {
    super.connectedCallback(), this.addEventListener(
      "click",
      (t) => {
        (this.disabled || this.hasAttribute("disabled") || this.isLoading) && (t.preventDefault(), t.stopImmediatePropagation());
      },
      !0
    ), this.addEventListener(
      "keydown",
      (t) => {
        (this.disabled || this.hasAttribute("disabled") || this.isLoading) && (t.key === "Enter" || t.key === " ") && (t.preventDefault(), t.stopImmediatePropagation());
      },
      !0
    );
  }
  attributeChangedCallback(t, o, n) {
    super.attributeChangedCallback(t, o, n), t === "disabled" && n === "false" && (this.disabled = !1), (t === "isloading" || t === "isLoading") && n === "false" && (this.isLoading = !1);
  }
  firstUpdated(t) {
    super.firstUpdated(t), this.disabled === "false" && (this.disabled = !1), this.isLoading === "false" && (this.isLoading = !1);
  }
  // Render
  render() {
    const t = this.form ?? this.getAttribute("form") ?? void 0, o = {
      "pkt-btn": !0,
      [`pkt-btn--${this.size}`]: !!this.size,
      [`pkt-btn--${this.skin}`]: !!this.skin,
      [`pkt-btn--${this.variant}`]: !!this.variant,
      [`pkt-btn--${this.color}`]: !!this.color,
      [`pkt-btn--${this.state}`]: !!this.state,
      "pkt-btn--full": !!this.fullWidth,
      "pkt-btn--full-small": !!this.fullWidthOnMobile,
      "pkt-btn--disabled": !!this.disabled,
      "pkt-btn--isLoading": !!this.isLoading
    };
    return l`
      <button
        class=${m(o)}
        type=${this.type}
        ?disabled=${!!this.disabled}
        aria-busy=${r(this.isLoading ? "true" : void 0)}
        aria-disabled=${r(this.disabled || this.isLoading ? "true" : void 0)}
        form=${r(t)}
      >
        ${this.isLoading ? l`<pkt-icon
              class="pkt-btn__icon pkt-btn__spinner"
              name="spinner-blue"
              path=${r(this.loadingAnimationPath)}
            ></pkt-icon>` : b}
        ${this.variant !== "label-only" ? l`<pkt-icon
              class="pkt-btn__icon pkt-icon"
              name=${this.iconName}
              path=${r(this.iconPath)}
            ></pkt-icon>` : b}
        <span class="pkt-btn__text" ${k(this.defaultSlot)}></span>
        ${this.variant === "icons-right-and-left" ? l`<pkt-icon
              class="pkt-btn__icon"
              name=${this.secondIconName}
              path=${r(this.secondIconPath)}
            ></pkt-icon>` : b}
      </button>
    `;
  }
};
e([
  s({ type: String })
], i.prototype, "iconName", 2);
e([
  s({ type: String })
], i.prototype, "secondIconName", 2);
e([
  s({ type: String })
], i.prototype, "iconPath", 2);
e([
  s({ type: String })
], i.prototype, "secondIconPath", 2);
e([
  s({ type: String })
], i.prototype, "mode", 2);
e([
  s({ type: String })
], i.prototype, "size", 2);
e([
  s({ type: Boolean, attribute: "full-width" })
], i.prototype, "fullWidth", 2);
e([
  s({ type: Boolean, attribute: "full-width-on-mobile" })
], i.prototype, "fullWidthOnMobile", 2);
e([
  s({ type: String })
], i.prototype, "color", 2);
e([
  s({ type: String })
], i.prototype, "skin", 2);
e([
  s({ type: String })
], i.prototype, "variant", 2);
e([
  s({ type: String, reflect: !0 })
], i.prototype, "state", 2);
e([
  s({ type: String, reflect: !0 })
], i.prototype, "type", 2);
e([
  s({ type: String })
], i.prototype, "form", 2);
e([
  s({ type: Boolean, reflect: !0 })
], i.prototype, "isLoading", 2);
e([
  s({ type: Boolean, reflect: !0 })
], i.prototype, "disabled", 2);
e([
  s({ type: String })
], i.prototype, "loadingAnimationPath", 2);
i = e([
  f("pkt-button")
], i);
export {
  i as P
};
